<template>
    <div id="header">
        <div v-onscroll:navbar class="nav">
            <router-link class="nav__brand" tag="a" to="/"><img class="brand__logo" src="../assets/logo.png"/></router-link>
            <ul class="nav__links">
                <li class="dropdown">
                    <router-link class="dropbtn nav__link" exact active-class="active" tag="a" to="/">Accueil</router-link>
                    <div class="dropdown-content">
                        <router-link class="nav__link" exact active-class="active" tag="a" to="/home#job__cgi">CGI</router-link>
                        <router-link class="nav__link" exact active-class="active" tag="a" to="/home#job__bell">Bell</router-link>
                        <router-link class="nav__link" exact active-class="active" tag="a" to="/home#job__novipro">Novipro</router-link>
                        <router-link class="nav__link" exact active-class="active" tag="a" to="/home#job__imds">IMDS</router-link>
                        <router-link class="nav__link" exact active-class="active" tag="a" to="/home#job__pixel">Pixel Artifex</router-link>
                        <router-link class="nav__link" exact active-class="active" tag="a" to="/home#scroller">Projets</router-link>
                        <a class="nav__link" href="./CV-Alain-LAM-genie-TI.pdf" target="_blank">CV en PDF</a>
                    </div>
                </li>
                <router-link class="nav__link" exact active-class="active" tag="li" to="/hobby">Loisir</router-link>
                <!-- <router-link class="nav__link" exact active-class="active" tag="li" to="/contact">Contact</router-link> -->
            </ul>
		</div>
    </div>
</template>

<script>
export default {

}
</script>

<style>
    #header {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 10vh;
        z-index: 50;
    }

    .nav {
        display: flex;
        height: 100%;
        padding: 0 1.5rem;
        justify-content: space-between;
        align-items: center;
        transition: all 1s ease-out;
        overflow: hidden;
    }

	.nav.solid {
		background-color:rgba(32, 32, 32, 0.97);
        color: #b1b1b1;
	}

    .brand__logo {
        width: 2.5rem;
    }

    .nav__links {
        margin: 0;
        padding: 0;
        list-style: none;
        display: flex;
    }

    .nav__link {
        margin: 0 0.8rem;
        cursor: pointer;
    }

    .nav__link:hover,
    .nav__link.active {
        color: #ffffff;
        cursor: pointer;
    }

    .nav.solid .active {
        color: #ffffff
    }

    .dropbtn {
        text-decoration: none;
        cursor: pointer;
        color: black;
    }

    .solid .dropbtn {
        color: #b1b1b1;
    }

    li.dropdown {
        display: inline-block;
    }

    .dropdown-content {
        display: none;
        position: absolute;
        right: 2rem;
        background-color: rgba(156, 156, 156, 0.822);
        box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
        z-index: 1;
    }

    .solid .dropdown-content {
        background-color: rgba(32, 32, 32, 0.97);
    }

    .dropdown-content a {
        color: inherit;
        padding: 12px 16px;
        text-decoration: none;
        display: block;
        text-align: left;
        margin: 0;
    }

    .dropdown:hover .dropdown-content {
        display: block;
    }

    .dropdown-content a:hover {
        background-color: rgba(32, 32, 32, 0.705);
    }

    @media (min-width: 40rem) {
        #header {
            height: 8vh;
        }
    }
</style>
